import React from 'react';
import Banner from '../components/Banner';
import CodeArea from '../components/CodeArea';

const Home = () => {
  return (
    <>
      <Banner/>
      <CodeArea/>
    </>
  );
};

export default Home;